import { DotLottie } from '@lottiefiles/dotlottie-web';
import { throttle } from 'throttle-debounce';

export default () => {
    const animations = document.querySelectorAll('[data-lottie]');
    const lottieMap = new Map();
    const playedElements = new Set();

    for (const el of animations) {
        const instance = new DotLottie({
            autoplay: false,
            loop: true,
            canvas: el,
            src: el.dataset.lottie,
            renderConfig: {
                freezeOnOffscreen: false,
            },
        });

        lottieMap.set(el, instance);
        instance.load();
    }

    const checkVisibility = () => {
        animations.forEach((el) => {
            if (playedElements.has(el)) return;

            const lottieInstance = lottieMap.get(el);
            if (!lottieInstance) return;

            const rect = el.getBoundingClientRect();
            const isVisible =
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth);

            if (isVisible && !lottieInstance.isPlaying) {
                lottieInstance.play();
                playedElements.add(el);
            }
        });
    };

    window.addEventListener('scroll', throttle(100, checkVisibility));
    setTimeout(checkVisibility, 1000);
};
